import NewAgreementSecondStep from './NewAgreementSecondStep';

export default NewAgreementSecondStep;
